// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2025 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

import { IJSONSchema } from '@glittr/frontend-core/src/plugins/validation/IJSONSchema';
import ResourceLinkSchema from './resource-link-schema';

const schema = {
  $id: '/fup-exercise-setting-list-schema',
  type: 'object',
  required: ['numberOfExecutions'],
  nullable: true,
  properties: {
    id: {
      type: 'string',
      format: 'uuid',
    },
    links: {
      type: 'array',
      nullable: true,
      items: { ...ResourceLinkSchema },
    },
    organisationId: {
      type: 'string',
      format: 'uuid',
      nullable: true,
    },
    numberOfExecutions: {
      type: 'integer',
    },
    title: {
      type: 'string',
      nullable: true,
    },
  },
} as IJSONSchema;

export default schema;
